import {useState, useCallback} from 'react';

export const usePagination = (initialPage = 1, initialPageSize = 20) => {
  const [page, setPage] = useState(initialPage);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [totalDocuments, setTotalDocuments] = useState(0);

  const handlePageChange = useCallback(
    (newPage, newPageSize) => {
      setPage(newPage);
      if (newPageSize && newPageSize !== pageSize) {
        setPageSize(newPageSize);
      }
    },
    [pageSize]
  );

  const handlePageSizeChange = useCallback((current, newPageSize) => {
    setPageSize(newPageSize);
    setPage(1); // Reset to first page when changing page size
  }, []);

  const resetPagination = useCallback(() => {
    setPage(1);
  }, []);

  return {
    page,
    pageSize,
    totalDocuments,
    setTotalDocuments,
    handlePageChange,
    handlePageSizeChange,
    resetPagination,
  };
};
